<template>
	<div class="receiveReward">
		<div class="receiveReward_main">
			<img @click="closeBg" class="receiveReward_contentX" src="./images/closeX.png" />
			<div class="receiveReward_content">
				<div class="answer_box_main">
					<img class="answer_box_img" :src="jiangliRes.levelLogo" />
					<div class="answer_box_text">{{jiangliRes.levelName}}</div>
					<div class="answer_box_desc" v-if='Number(jiangliRes.correctAnswerNum) == 0'>还差5题，就能全部答对哦！</div>
					<div class="answer_box_desc" v-else-if='0<Number(jiangliRes.correctAnswerNum) && Number(jiangliRes.correctAnswerNum)<Number(jiangliRes.questionNum)'>差一点，5题全对哦！</div>
					<div class="answer_box_desc" v-else>恭喜您，5题全部答对啦！</div>
					<div class="reward_box">
						<div class="reward_box_line"></div>
						<div class="reward_box_text">您获得了{{jiangliRes.rewardList[0].valueDesc}}答题专属福利折扣券</div>
						<div class="reward_box_line"></div>
					</div>
					<div class="answer_box_coupon_box">
						<div class="answer_box_coupon_content">
							<div class="answer_box_coupon_left">
								<div class="answer_box_coupon_text">{{jiangliRes.rewardList[0].rewardDesc}}</div>
								<div class="answer_box_coupon_date">{{jiangliRes.rewardList[0].rewardEffectiveBeginTime.split(" ")[0]}}  ~  {{jiangliRes.rewardList[0].rewardEffectiveEndTime.split(" ")[0]}}</div>
							</div>
							<div class="answer_box_coupon_line"></div>
							<div class="answer_box_coupon_right">{{jiangliRes.rewardList[0].valueDesc}}</div>
						</div>
					</div>
					<div class="answer_box_tip">折扣券已自动发放至个人中心，可立即使用</div>
				</div>
				<div class="answer_button" @mouseenter="enterQr" @mouseleave="leaveQr">打开微信扫一扫，分享海报至朋友圈再得一张</div>
				<div style="position: fixed;margin-left: 360px;margin-top: -150px;" v-show="answerQrShow">
                    <div class="answer_qr_tip">
                        用微信扫码二维码
                        分享至好友和朋友圈
                    </div>
					<div class="answer_qr">
						<img class="answer_qr_img" :src="qrCode" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {getUserQrCode} from '@/api/activity.js'
	export default {
		props: {
			jiangliRes: {//数据列表
				type: Object,
				default:null
			},
            activityId: {//数据列表
				type: String,
				default:""
			},
		},
		data() {
			return {
				qrCode:'',
				answerQrShow:false,

			}
		},
		mounted() {
			this._getUserQrCode(this.activityid);
			console.log(this.jiangliRes)
		},
        methods:{
			closeBg() {
				this.$emit('isSuccess')
				// this.bg_show = false;
				// this.$router.push('/huodong/zhishichanquanri.html')
			},
			_getUserQrCode() {
				let params = {
					activityId: this.activityId,
				}
				getUserQrCode(this.activityId,params).then(res => {
					if (res.code == 200) {
						this.qrCode  = res.result;
					}
				})
			},
			enterQr(){
				this.answerQrShow=true;
			},
			leaveQr(){
				this.answerQrShow=false;
			},
		}
	}
</script>

<style>
.receiveReward{
	position: fixed;
    left: 0;
    top:0px;
	width: 100%;
	height: 100%;
	padding-top: 50px;
	box-sizing: border-box;
	background: rgb(0,0,0,0.7);
	z-index:3;
}
.receiveReward_main{
	margin:0 auto;
	width: 373px;
	text-align: left;
}
.receiveReward_content{
	width: 351px;
}
.receiveReward_contentX{
	margin-left: 351px;
	margin-bottom: -12px;
	cursor: pointer;
}
.answer_box_main{
	width: 351px;
	height: 497px;
	background: url(./images/receiveReward.png) no-repeat center center;
	background-size: 100% 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
}
.answer_box_img{
	margin:0 auto;
	width: 248px;
	height: 200px;
	cursor:pointer;
}
.answer_box_img img{
	width: 100%;
	height: 100%;
}
.answer_box_text{
	margin-top: 5px;
	font-size: 20px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #404E57;
	text-align: center;
	line-height: 21px;
}
.answer_box_desc{
	margin-top: 10px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #999999;
	text-align: center;
	line-height: 21px;
}
.reward_box{
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
}
.reward_box_line{
	width: 16px;
	height: 1px;
	background: #999999;
	border-radius: 1px;
}
.reward_box_text{
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #404E57;
	margin-right: 5px;
	margin-left: 5px;
}

.answer_box_coupon_box{
	margin:0 auto;
	margin-top: 12px;
	width: 298px;
	height: 76px;
	background: #FEF3E2;
	box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
	border-radius: 12px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.answer_box_coupon_content{
	width: 289px;
	height: 67px;
	background: rgba(255, 255, 255, 0.6);
	border: 1px solid #FDCD52;
	border-radius: 12px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}

.answer_box_coupon_left{
	display: flex;
	flex-direction: column;
}
.answer_box_coupon_text{
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #404E57;
	text-align: left;
}
.answer_box_coupon_date{
	margin-top: 9px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #B0B0B0;
	text-align: left;
}
.answer_box_coupon_line{
	height: 54px;
	border: 1px dashed #ECBF78;
	opacity: 0.5;
	margin-left: 8px;
	margin-right: 8px;
}
.answer_box_coupon_right{
	font-size: 20px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #FF3E50;
}

.answer_box_tip{
	margin-top: 15px;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #B0B0B0;
	text-align: center;
	line-height: 21px;
}

.answer_button{
	margin:0 auto;
	margin-top: 33px;
	width: 336px;
	height: 43px;
	background: linear-gradient(0deg, #FDCA4F 0%, #FEE571 60%, #FDF0B1 100%);
	box-shadow: 0px 3px 10px 0px rgba(253, 213, 161, 0.3);
	border-radius: 20px;

	text-align: center;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #7A4D13;
	line-height: 43px;
	cursor:pointer;
}

.answer_qr{
	margin:0 auto;
	margin-top: 12px;
	width: 120px;
	height: 127px;
	background: url(./images/qrbg.png) no-repeat center center;
	background-size: 100% 100%;
	text-align: center;
}

.answer_qr_img{
	width: 104px;
	height:104px;
	margin-top: 13px;
    margin-left: 7px;
}

.answer_qr_tip{
	margin:0 auto;
	margin-top: 15px;
	width: 126px;
	height: 34px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #CCCCCC;
	line-height: 20px;
	text-align: center;
}
</style>
